import { RouterType } from '@online-webinar/router';
import { ChatSettingsPage } from '@online-webinar/webinar-management';
import { authGuard } from '../integrations/auth-guard';

export const updateRoute = (router: RouterType) => {
    router.routesById['/$webinarId/chat-settings'].update({
        staticData: { title: { page: 'ChatSettings.PageHeading', forWebinar: true } },
        component: authGuard(ChatSettingsPage, { canBroadcast: true })
    });
};
